import React from 'react';

const TemplateIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.25C0 1.00736 1.00736 0 2.25 0H15.75C16.9926 0 18 1.00736 18 2.25V11.75C18 12.9926 16.9926 14 15.75 14H2.25C1.00736 14 0 12.9926 0 11.75V2.25ZM1.5 8.06066V11.75C1.5 12.1642 1.83579 12.5 2.25 12.5H15.75C16.1642 12.5 16.5 12.1642 16.5 11.75V9.06066L14.2803 6.84099C13.9874 6.5481 13.5126 6.5481 13.2197 6.84099L11.3107 8.75L11.7803 9.21967C12.0732 9.51256 12.0732 9.98744 11.7803 10.2803C11.4874 10.5732 11.0126 10.5732 10.7197 10.2803L5.53033 5.09099C5.23744 4.7981 4.76256 4.7981 4.46967 5.09099L1.5 8.06066ZM11 4C11 4.55228 10.5523 5 10 5C9.44771 5 9 4.55228 9 4C9 3.44772 9.44771 3 10 3C10.5523 3 11 3.44772 11 4Z"
      fill="currentColor"
    />
  </svg>
);

export default TemplateIcon; 